import { raceOptions } from '../../../../components/LeaseAffordableApplicantFormCommonSections/configuration';

export function generateRaceField({
  propertyStateCode,
  name = 'multiRace',
  GridProps = { xs: 12, sm: 3 },
}) {
  const races = raceOptions(propertyStateCode, { withDefault: false });

  return {
    variant: 'multiSelect',
    name,
    label: 'Race',
    placeholder: 'Select',
    options: races,
    rules: {
      required: true,
    },
    GridProps,
  };
}
